import { render } from "./DownloadCopilot.vue?vue&type=template&id=b8bfd1b2"
import script from "./DownloadCopilot.vue?vue&type=script&lang=js"
export * from "./DownloadCopilot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__